export const toApiPage = (zeroBasedPage: number): number => zeroBasedPage + 1

export const getServerPaginationUpdate = (
  currentPageSize: number,
  newPage: number,
  newPageSize: number
) => ({
  page: newPageSize === currentPageSize ? newPage : 0,
  pageSize: newPageSize,
})
